/** O widget carrega assíncrono: espera o `window.Pylon` por até 15s e desiste em silêncio. */
export function whenPylonReady(callback: (pylon: (command: string) => void) => void, deadline = Date.now() + 15_000): void {
  const pylon = (window as Window & { Pylon?: (command: string) => void }).Pylon;
  if (pylon) {
    callback(pylon);
    return;
  }
  if (Date.now() < deadline) {
    setTimeout(() => whenPylonReady(callback, deadline), 500);
  }
}
